import { useLayoutEffect, useRef, useState, useEffect } from "react";

const BASE = "w-full px-3 py-2.5 rounded-lg bg-white border border-[var(--border)] outline-none focus:border-[#FC82ED] transition-colors";

// Riquadro per testi lunghi: min ~5 righe, cresce fino a metà schermo, poi scorre; 16px su mobile (no zoom iOS).
export function LongTextarea({ value, onChange, className = "", minRows = 5, onFocus, style, rows, ...rest }) {
  const ref = useRef(null);
  const resize = () => {
    const el = ref.current;
    if (!el) return;
    const max = Math.round(window.innerHeight * 0.5);
    el.style.height = "auto";
    const h = Math.min(el.scrollHeight + 2, max);
    el.style.height = `${h}px`;
    el.style.overflowY = el.scrollHeight + 2 > max ? "auto" : "hidden";
  };
  useLayoutEffect(resize, [value]);
  const focus = (e) => {
    setTimeout(() => ref.current?.scrollIntoView({ block: "center", behavior: "smooth" }), 300);
    onFocus && onFocus(e);
  };
  return (
    <textarea ref={ref} rows={minRows} value={value ?? undefined} onChange={onChange} onFocus={focus} onInput={resize}
      style={{ minHeight: `calc(${minRows} * 1.5em + 1.25rem)`, maxHeight: "50vh", lineHeight: 1.5, ...style }}
      className={`${className || BASE} long-textarea block resize-y whitespace-pre-wrap`} {...rest} />
  );
}

// Visualizzazione nota: a capo rispettati; se lunga mostra le prime righe + "Mostra tutto".
export function NoteView({ text, lines = 4, className = "", testid }) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [long, setLong] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (el && !open) setLong(el.scrollHeight > el.clientHeight + 2);
  }, [text, open]);
  if (!text) return null;
  const clamp = open ? {} : { display: "-webkit-box", WebkitLineClamp: lines, WebkitBoxOrient: "vertical", overflow: "hidden" };
  return (
    <div className={className} data-testid={testid}>
      <div ref={ref} className="whitespace-pre-wrap break-words" style={clamp}>{text}</div>
      {(long || open) && (
        <button type="button" data-testid={testid ? `${testid}-toggle` : "note-toggle"} onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
          className="mt-0.5 text-[11px] font-semibold text-[#b84fae] hover:underline">{open ? "Mostra meno" : "Mostra tutto"}</button>
      )}
    </div>
  );
}
